import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const SaveIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 36 36" {...props}>
      {/* Outer frame with notch */}
      <path
        d="M7.5 4.5c-1.65 0-3 1.35-3 3v21c0 1.65 1.35 3 3 3h21c1.65 0 3-1.35 3-3V10.5l-6-6H7.5z"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Circular save indicator */}
      <path
        d="M18 18c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Label slot rectangle */}
      <path
        d="M9 9h13.5v6H9z"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default SaveIcon;
